<template>

  <el-alert
    v-if="shopCtx.listTip"
    class="mb-3!"
    :title="shopCtx.listTip"
    :type="shopCtx.multiSelfAbnormal || shopCtx.emptySelfShops ? 'warning' : 'info'"
    show-icon
    :closable="false"
  />

  <!-- 售后类型 Tab -->
  <ContentWrap>
    <el-tabs v-model="afterSaleTab" @tab-change="handleTabChange">
      <el-tab-pane label="实物售后" name="PHYSICAL" />
      <el-tab-pane label="服务售后" name="SERVICE" />
    </el-tabs>
  </ContentWrap>

  <!-- 搜索 -->
  <ContentWrap>
    <el-form ref="queryFormRef" :inline="true" :model="queryParams" label-width="68px">
      <el-form-item
        v-if="shopCtx.selfScope ? shopCtx.multiSelfAbnormal : true"
        label="所属店铺"
        prop="shopId"
      >
        <el-select
          v-model="selectedShopId"
          class="!w-280px"
          clearable
          filterable
          :placeholder="shopCtx.selfScope ? '全部自营店汇总' : '全部'"
        >
          <el-option
            v-for="item in shopFilterOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="商品名称" prop="spuName">
        <el-input
          v-model="queryParams.spuName"
          class="!w-280px"
          clearable
          :placeholder="isServiceTab ? '请输入服务名称' : '请输入商品 SPU 名称'"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="退款编号" prop="no">
        <el-input
          v-model="queryParams.no"
          class="!w-280px"
          clearable
          placeholder="请输入退款编号"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="订单编号" prop="orderNo">
        <el-input
          v-model="queryParams.orderNo"
          class="!w-280px"
          clearable
          placeholder="请输入订单编号"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="售后状态" prop="status">
        <el-select
          v-model="queryParams.status"
          class="!w-280px"
          clearable
          placeholder="请选择售后状态"
        >
          <el-option label="全部" value="0" />
          <el-option
            v-for="dict in getDictOptions(DICT_TYPE.TRADE_AFTER_SALE_STATUS)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="售后方式" prop="way">
        <el-select
          v-model="queryParams.way"
          class="!w-280px"
          clearable
          placeholder="请选择售后方式"
        >
          <el-option
            v-for="dict in getDictOptions(DICT_TYPE.TRADE_AFTER_SALE_WAY)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="售后类型" prop="type">
        <el-select
          v-model="queryParams.type"
          class="!w-280px"
          clearable
          placeholder="请选择售后类型"
        >
          <el-option
            v-for="dict in getDictOptions(DICT_TYPE.TRADE_AFTER_SALE_TYPE)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker
          v-model="queryParams.createTime"
          :default-time="[new Date('1 00:00:00'), new Date('1 23:59:59')]"
          class="!w-280px"
          end-placeholder="自定义时间"
          start-placeholder="自定义时间"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-tabs v-model="queryParams.status" @tab-click="tabClick">
      <el-tab-pane
        v-for="item in statusTabs"
        :key="item.label"
        :label="item.label"
        :name="item.value"
      />
    </el-tabs>
    <!-- 列表 -->
    <el-table v-loading="loading" :data="list">
      <el-table-column label="店铺" width="100">
        <template #default="{ row }">{{ shopName(row.shopId) }}</template>
      </el-table-column>
      <el-table-column align="center" label="退款编号" min-width="200" prop="no" />
      <el-table-column align="center" label="订单编号" min-width="200" prop="orderNo">
        <template #default="{ row }">
          <el-button link type="primary" @click="openOrderDetail(row.orderId)">
            {{ row.orderNo }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column :label="isServiceTab ? '服务信息' : '商品信息'" min-width="600" prop="spuName">
        <template #default="{ row }">
          <div class="flex items-center">
            <el-image
              :src="row.picUrl"
              class="mr-10px h-30px w-30px"
              @click="imagePreview(row.picUrl)"
            />
            <span class="mr-10px">{{ row.spuName }}</span>
            <el-tag v-for="property in row.properties" :key="property.propertyId" class="mr-10px">
              {{ property.propertyName }}: {{ property.valueName }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="订单金额" min-width="120" prop="refundPrice">
        <template #default="scope">
          <span>{{ fenToYuan(scope.row.refundPrice) }} 元</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="买家" prop="user.nickname" />
      <el-table-column align="center" label="申请时间" prop="createTime" width="180">
        <template #default="scope">
          <span>{{ formatDate(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="售后状态" width="100">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.TRADE_AFTER_SALE_STATUS" :value="scope.row.status" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="售后方式">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.TRADE_AFTER_SALE_WAY" :value="scope.row.way" />
        </template>
      </el-table-column>
      <el-table-column align="center" fixed="right" label="操作" width="160">
        <template #default="{ row }">
          <el-button link type="primary" @click="openAfterSaleDetail(row.id)">
            {{ isAfterSaleApplying(row.status) ? '处理退款' : '查看售后' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>
</template>
<script lang="ts" setup>
import * as AfterSaleApi from '@/api/mall/trade/afterSale/index'
import { DICT_TYPE, getDictOptions } from '@/utils/dict'
import { formatDate } from '@/utils/formatTime'
import { createImageViewer } from '@/components/ImageViewer'
import { TabsPaneContext } from 'element-plus'
import { cloneDeep } from 'lodash-es'
import { fenToYuan } from '@/utils'
import { useShopName } from '@/hooks/web/useShopName'
import { useMallStandaloneNav } from '@/hooks/web/useMallStandaloneNav'
import { useMallSelfShopContext } from '@/hooks/web/useMallSelfShopContext'
import { getShopSimpleList } from '@/api/merchant/shop-manager'

defineOptions({ name: 'TradeAfterSale' })
const { shopName } = useShopName()

const { pushMall } = useMallStandaloneNav()
const {
  context: shopCtx,
  applyShopFilterToQuery,
  refresh: refreshShopCtx
} = useMallSelfShopContext()

const afterSaleTab = ref<'PHYSICAL' | 'SERVICE'>('PHYSICAL')
const isServiceTab = computed(() => afterSaleTab.value === 'SERVICE')

const loading = ref(true) // 列表的加载中
const total = ref(0) // 列表的总页数
const list = ref<AfterSaleApi.TradeAfterSaleVO[]>([]) // 列表的数据
const statusTabs = ref([
  {
    label: '全部',
    value: '0'
  }
])
const queryFormRef = ref() // 搜索的表单
const selectedShopId = ref<number | undefined>()
const shopFilterOptions = ref<{ id: number; name: string }[]>([])
// 查询参数
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  no: null,
  status: '0',
  orderNo: null,
  spuName: null,
  createTime: [],
  way: null,
  type: null,
  fulfillmentTypeGroup: 'PHYSICAL' as 'PHYSICAL' | 'SERVICE',
  shopId: undefined as number | undefined,
  shopIds: undefined as number[] | undefined
})

const refreshShopFilterOptions = async () => {
  await refreshShopCtx()
  if (shopCtx.value.selfScope) {
    shopFilterOptions.value = shopCtx.value.shops.map((s) => ({
      id: s.id,
      name: s.name || `店铺${s.id}`
    }))
    if (shopCtx.value.singleShopId) {
      selectedShopId.value = shopCtx.value.singleShopId
    } else if (
      selectedShopId.value &&
      !shopFilterOptions.value.some((s) => s.id === selectedShopId.value)
    ) {
      selectedShopId.value = undefined
    }
  } else {
    const shops = (await getShopSimpleList()) as { id: number; name: string }[]
    shopFilterOptions.value = (shops || []).map((s) => ({
      id: s.id,
      name: s.name || `店铺${s.id}`
    }))
    selectedShopId.value = undefined
  }
}

/** Tab 切换 */
const handleTabChange = () => {
  queryParams.fulfillmentTypeGroup = afterSaleTab.value
  queryParams.pageNo = 1
  getList()
}

/** 查询列表 */
const getList = async () => {
  loading.value = true
  try {
    const data = cloneDeep(queryParams) as Record<string, any>
    if (shopCtx.value.selfScope) {
      applyShopFilterToQuery(data, selectedShopId.value)
    } else {
      delete data.shopIds
      data.shopId = selectedShopId.value
    }
    // 处理掉全部的状态，不传就是全部
    const queryData = data.status === '0' ? (({ status: _status, ...rest }) => rest)(data) : data
    // 执行查询
    const res = await AfterSaleApi.getAfterSalePage(queryData)
    list.value = res.list as AfterSaleApi.TradeAfterSaleVO[]
    total.value = res.total
  } finally {
    loading.value = false
  }
}

/** 搜索按钮操作 */
const handleQuery = async () => {
  queryParams.pageNo = 1
  await getList()
}

/** 重置按钮操作 */
const resetQuery = async () => {
  queryFormRef.value?.resetFields()
  queryParams.fulfillmentTypeGroup = afterSaleTab.value
  await refreshShopFilterOptions()
  await handleQuery()
}

/** tab 切换 */
const tabClick = async (tab: TabsPaneContext) => {
  if (tab.paneName === undefined) {
    return
  }
  queryParams.status = String(tab.paneName)
  await getList()
}

/**
 * 进行中的售后（与后端 AfterSaleStatusEnum.APPLYING_STATUSES 对齐）：
 * 10 申请中 / 20 待退货 / 30 待收货 / 40 待退款 → 仍可处理
 * 50/61/62/63 终态 → 仅查看
 */
const AFTER_SALE_APPLYING_STATUSES = new Set([10, 20, 30, 40])
const isAfterSaleApplying = (status?: number | null) =>
  status != null && AFTER_SALE_APPLYING_STATUSES.has(Number(status))

/** 打开售后详情（文案按是否进行中区分） */
const openAfterSaleDetail = (id: number) => {
  pushMall(`/trade/after-sale/detail/${id}`)
}

/** 查看订单详情 */
const openOrderDetail = (id: number) => {
  pushMall(`/trade/order/detail/${id}`)
}

/** 商品图预览 */
const imagePreview = (imgUrl: string) => {
  createImageViewer({
    urlList: [imgUrl]
  })
}

watch(
  () => shopCtx.value.selfScope,
  async () => {
    await refreshShopFilterOptions()
    await handleQuery()
  }
)

onMounted(async () => {
  await refreshShopFilterOptions()
  await getList()
  // 设置 statuses 过滤
  for (const dict of getDictOptions(DICT_TYPE.TRADE_AFTER_SALE_STATUS)) {
    statusTabs.value.push({
      label: dict.label,
      value: dict.value
    })
  }
})
</script>

